<div class="ui modal" id="Info_Modal">

    <div class="header" style="background-color:#DCDCDC">
        <span tkey="INFO"></span>
        <button style="float:right;background-color: white;border: 1px solid;" class="circular ui icon button" (click)="InfoModal_Close()">
            <i class="remove link icon"></i>
        </button>
    </div>

    <div class="content" style="height:600px; background: #dcdcdc">
      <div style="width: 100%; height: 100%;" *ngIf="this.selectedMenuID === 'overview'">
        <iframe src="/PDF/de_overview.pdf#view=fitH&toolbar=0&navpanes=0&scrollbar=0&statusbar=0&zoom=scale" style="width: 100%; height: 100%;" frameborder="0" scrolling="no">
        </iframe>
      </div>
      <div style="width: 100%; height: 100%;" *ngIf="this.selectedMenuID === 'bet_types'">
        <iframe src="/PDF/de_bet_types.pdf#view=fitH&toolbar=0&navpanes=0&scrollbar=0&statusbar=0" style="width: 100%; height: 100%;" frameborder="0" scrolling="no">
        </iframe>
      </div>
      <div style="width: 100%; height: 100%;" *ngIf="this.selectedMenuID === 'bet_variation'">
        <iframe src="/PDF/de_bet_variation.pdf#view=fitH&toolbar=0&navpanes=0&scrollbar=0&statusbar=0" style="width: 100%; height: 100%;" frameborder="0" scrolling="no">
        </iframe>
      </div>
      <div style="width: 100%; height: 100%;" *ngIf="this.selectedMenuID === 'deposit'">
        <iframe src="/PDF/de_deposit.pdf#view=fitH&toolbar=0&navpanes=0&scrollbar=0&statusbar=0" style="width: 100%; height: 100%;" frameborder="0" scrolling="no">
        </iframe>
      </div>
      <div style="width: 100%; height: 100%;" *ngIf="this.selectedMenuID === 'betting_rules'">
        <iframe src="/PDF/de_betting_rules.pdf#view=fitH&toolbar=0&navpanes=0&scrollbar=0&statusbar=0" style="width: 100%; height: 100%;" frameborder="0" scrolling="no">
        </iframe>
      </div>
      <div style="width: 100%; height: 100%;" *ngIf="this.selectedMenuID === 'addiction_preventation'">
        <iframe src="/PDF/de_addiction_preventation.pdf#view=fitH&toolbar=0&navpanes=0&scrollbar=0&statusbar=0" style="width: 100%; height: 100%;" frameborder="0" scrolling="no">
        </iframe>
      </div>
    </div>
    <div class="content" style="height:70px; text-align: center; background: #dcdcdc">
      <button class="ui button switchType modalSmall {{this.selectedMenuID === 'betting_rules' ? 'active' : ''}}" (click)="setMenu('betting_rules')">
        <span>Wettbestimmungen</span>
      </button>
        <button class="ui button switchType modalSmall {{this.selectedMenuID === 'overview' ? 'active' : ''}}" (click)="setMenu('overview')">
            <span>Übersicht</span>
        </button>
        <button class="ui button switchType modalSmall {{this.selectedMenuID === 'bet_types' ? 'active' : ''}}" (click)="setMenu('bet_types')">
            <span>Wettarten</span>
        </button>
        <button class="ui button switchType modalSmall {{this.selectedMenuID === 'bet_variation' ? 'active' : ''}}" (click)="setMenu('bet_variation')">
            <span>Wettvarianten</span>
        </button>
        <button class="ui button switchType modalSmall {{this.selectedMenuID === 'deposit' ? 'active' : ''}}" (click)="setMenu('deposit')">
            <span tkey="Deposit/Payout">Ein-/Auszahlung</span>
        </button>

        <button class="ui button switchType modalSmall {{this.selectedMenuID === 'addiction_preventation' ? 'active' : ''}}" (click)="setMenu('addiction_preventation')">
            <span tkey="Addiction_prevention"></span>
        </button>

        <!--<button class="ui icon button" (click)="SignOut()">
            <i class="sign out alternate icon"></i>
        </button>-->
    </div>
</div>
